import { HttpErrorResponse } from '@angular/common/http';
import {
  SessionPayment,
  SessionPaymentTransaction,
} from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const HostedPaymentsReviewPaymentComponentSessionActions =
  createActionGroup({
    source: 'Hosted Payments Review Payment Component - Session',
    events: {
      'Update Session Payment Success': props<{
        response: SessionPayment;
      }>(),
      'Update Session Payment Failed': props<{
        error: HttpErrorResponse;
      }>(),
      'Session Payment Transactions Updated': props<{
        payload: SessionPaymentTransaction[];
      }>(),
      'Update Session Status To Active Success': emptyProps(),
      'Update Session Status To Active Failed': emptyProps(),
    },
  });
